(function () {
  if (window.NicaisePdfLanguageSelectorLoaded) {
    return;
  }

  window.NicaisePdfLanguageSelectorLoaded = true;

  function initializeSelector(root) {
    if (!root || root.dataset.pdfLanguageSelectorInitialized === 'true') {
      return;
    }

    root.dataset.pdfLanguageSelectorInitialized = 'true';

    if (root.dataset.languageHint !== 'true') {
      return;
    }

    var browserLanguage = '';

    if (navigator.languages && navigator.languages.length) {
      browserLanguage = navigator.languages[0];
    } else if (navigator.language) {
      browserLanguage = navigator.language;
    }

    browserLanguage = browserLanguage.toLowerCase();

    var preferredLanguage = null;

    if (browserLanguage.indexOf('fr') === 0) {
      preferredLanguage = 'fr';
    } else if (browserLanguage.indexOf('en') === 0) {
      preferredLanguage = 'en';
    }

    if (!preferredLanguage) {
      return;
    }

    var recommendedLink = root.querySelector(
      '[data-pdf-language="' + preferredLanguage + '"]'
    );

    if (
      !recommendedLink ||
      recommendedLink.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    recommendedLink.classList.add(
      'pdf-language-selector__button--recommended'
    );

    var badge = recommendedLink.querySelector('[data-recommended]');

    if (badge) {
      badge.hidden = false;
    }
  }

  function initializeAllSelectors(scope) {
    var selectors = scope.querySelectorAll(
      '[data-pdf-language-selector]'
    );

    selectors.forEach(function (selector) {
      initializeSelector(selector);
    });
  }

  function start() {
    initializeAllSelectors(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllSelectors(event.target);
  });
})();